<script>

    import { fade } from 'svelte/transition';

    import { createEventDispatcher } from "svelte";
    import IntroGraphic from './IntroGraphic.svelte';

    const dispatch = createEventDispatcher();

    export let data;

    let showMap = false;

</script>

<style>

    .landing-con {
        width: 100%;
        /* height: 100%; */
        background-color: white;
        opacity: 0.99;
        position: absolute;
        left: 0px;
        top: 0px;
        z-index: 1000;
        font-family: 'Roboto';
        overflow: auto;
        padding-bottom: 100px;
    }

    .hidden {
        display: none;
    }

    .body-con {
        max-width: 600px;
        margin: auto;
        margin-top: 16px;
    }

    .spy-logo {
        text-align: center;
        cursor: pointer;
    }

    .spy-logo img {
        width: 100px;
    }

    .headline {
        font-size: 54px;
        font-weight: 700;
        max-width: 600px;
        margin: auto;
        text-align: center;
        margin-top: 8px;
    }

    .publish-date {
        font-size: 12px;
        margin-top: 8px;
        color: #767676;
        text-align: center;
    }

    .body-copy {
        font-size: 1.25rem;
        line-height: 1.875rem;
        padding: 0px 15px;
    }

    .buttons-container {
        margin: auto;
        text-align: center;
    }

    button {
        background-color: #F8BE26;
        color: white;
        border: none;
        font-weight: 700;
        font-size: 1.25rem;
        border-radius: 5px;
        padding: 10px;
        cursor: pointer;
    }

    .image-con {
        margin: 8px 0px;
        cursor: pointer;
    }

    .image-con img {
        border: 1px solid #d9d9d9;
        width: 400px;
    }

    .standfirst {
        font-size: 24px;
        text-align: center;
    }

</style>

<div class='landing-con' class:hidden={showMap} out:fade>
    <div class='body-con'>
        <div class='header'>
            <div class='spy-logo'>
                <a href="https://www.thelondonspy.co.uk">
                <img src="./spy-logo.png" />
                </a>
            </div>
            <div class='headline'>
                A Tube map of<br/>London house prices
            </div>
            <!-- <div class='standfirst'>
                And here's what we learnt
            </div> -->
            <div class='publish-date'>
                Published on September 2, 2024
            </div>
        </div>
        <div class='graphic'>
            <IntroGraphic {data} />
        </div>
        <div class='body-copy'>
            <p>London's housing market can be rough. Prices are high everywhere, making it a massive challenge to find a neighbourhood even remotely in budget.</p>
            <!-- <p>The fact is, when you're choosing somewhere to buy in London, your local station matters. A lovely neighbourhood isn't much good if you can't get where you need for work or pleasure.</p> -->
            <p>So we've repurposed a Tube map to guide you through the madness. It shows the average property price within one kilometre of each station on the TfL network. We've calculated the average price in the year to August 2024 as well as the four years before.</p>
            <p>Start exploring the map in your browser using the button below.</p>
            <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean consequat congue velit et aliquet. Fusce eget vehicula orci. In sed sem sit amet eros feugiat feugiat vitae ac tellus.</p> -->
            <!-- <p>Donec gravida nibh ac purus pretium, eget laoreet ligula molestie. Proin a elementum est. Nulla facilisi. Aliquam maximus urna laoreet justo scelerisque vehicula.</p> -->
        </div>
        <div class='buttons-container'>
            <button on:click={() => dispatch('show-map')}>
                Explore house prices on the Tube
            </button>
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <div class='image-con' on:click={() => dispatch('show-map')}>
            <img src="./zoomed-preview-tube-map.png" />
            </div>
        </div>
        <div class='body-copy'>
            <p>This isn't our only housing Tube map. In June, we published a Tube map of London rents, showing how much a one-bed costs per month near each station.</p>
            <p>You can check it out — and support our work — using the button below.</p>
        </div>
        <div class='buttons-container'>
            <a href="https://www.thelondonspy.co.uk/p/we-made-a-tube-map-of-london-rents"><button>
                Explore rents on the Tube
            </button></a>
        </div>
    </div>
</div>